export default function permission() {
  const getPermissions = quote => {
    const perm = {
      can_update: false,
      can_delete: false,
    }
    const quotePermissions = quote.quote_permissions ? quote.quote_permissions : {}
    return {
      ...perm,
      ...quotePermissions,
    }
  }
  const canUpdate = quote => getPermissions(quote).can_update

  const canDelete = quote => getPermissions(quote).can_delete

  return {
    canUpdate,
    canDelete,
  }
}
